module.exports = __webpack_public_path__ + "static/media/industries-biofuel-s.88843aa0.jpg";